import { render, staticRenderFns } from "./OnionSamples.vue?vue&type=template&id=609ec444&scoped=true&"
import script from "./OnionSamples.vue?vue&type=script&lang=js&"
export * from "./OnionSamples.vue?vue&type=script&lang=js&"
import style0 from "./OnionSamples.vue?vue&type=style&index=0&id=609ec444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609ec444",
  null
  
)

export default component.exports